"use client";

import dynamic from "next/dynamic";

// Client-only lazy wrapper for ContactForm. ContactForm statically pulls in
// react-phone-number-input (~196 KB: PhoneInputWithCountry + the full country
// metadata table). Imported statically it landed in the /contact-us route
// chunk, which the homepage prefetches via the "Talk to an Expert" link — so
// every homepage visit downloaded 196 KB of form code it never runs.
//
// `ssr: false` splits it into a runtime chunk loaded only when this component
// mounts (i.e. on the contact page itself), keeping it off every other route's
// prefetch. Form inputs aren't ranking content, so losing their SSR HTML has no
// SEO cost; the page's headings, copy, and contact channels stay server-rendered.
const ContactForm = dynamic(() => import("./ContactForm"), {
  ssr: false,
  loading: () => (
    <div
      className="min-h-[560px] animate-pulse rounded-2xl border border-border-subtle bg-bg-surface/40"
      aria-hidden
    />
  ),
});

export default function ContactFormLazy() {
  return <ContactForm />;
}
